<template>
    <div>
        <div v-if="hasVFairs">
            <div class="relativeposition">
                <div class="headertext">
                    <div>Virtual Career Fairs</div>
                </div>
                <img :src="logo" class="schoolLogo" />
                <img :src="topBannerImage" class="topbanner" />
            </div>
            <!-- <Header :label="$t('vfair.header')" overlap="small" /> -->
            <div class="relativeposition">
                <div class="countdownwrapper">
                    <countdown
                        :caption="'Next Fair in'"
                        :timestamp="nextVFairTimeStamp"
                    ></countdown>
                </div>
                <MainLayout hide-on-mobile="left right">
                    <div slot="top">
                        <h4 class="pt-5">{{ $t('vfair.signUpToday') }}</h4>
                        <p class="mb-4">{{ $t('vfair.vfairsInfo') }}</p>
                    </div>
                    <VFairList
                        slot="top"
                        with-layout-toggle
                        :data="data()"
                        :is-loading="loading()"
                    />

                    <div slot="top" class="pt-5">
                        <h4>{{ $t('vfair.recruitingOrgs') }}</h4>
                    </div>

                    <Paper slot="top">
                        <CompanyList
                            :data="organizations"
                            :label="$t('vfair.preRegistered')"
                            :isLoading="companiesLoading"
                        ></CompanyList>
                    </Paper>

                    <div slot="top" class="pt-5">
                        <h4>{{ $t('vfair.prepareForTheFair') }}</h4>
                        <Paper class="p-3">
                            <div class="card-deck">
                                <LinkCard
                                    :img="masterClass"
                                    :title="$t('vfair.links.masterclasses.header')"
                                    :body="$t('vfair.links.masterclasses.description')"
                                    :buttonCaption="$t('vfair.links.masterclasses.buttonCaption')"
                                    routerTarget="/resources"
                                ></LinkCard>
                                <LinkCard
                                    :img="cv"
                                    :title="$t('vfair.links.cv.header')"
                                    :body="$t('vfair.links.cv.description')"
                                    :buttonCaption="$t('vfair.links.cv.buttonCaption')"
                                    :blankTarget="cvTemplateLink"
                                ></LinkCard>
                                <LinkCard
                                    :img="elevatorPitch"
                                    :title="$t('vfair.links.elevatorPitch.header')"
                                    :body="$t('vfair.links.elevatorPitch.description')"
                                    :buttonCaption="$t('vfair.links.elevatorPitch.buttonCaption')"
                                    blankTarget="https://forms.gle/MD6yp2C6T1o3Yb7B6"
                                ></LinkCard>
                            </div>
                        </Paper>
                    </div>
                </MainLayout>
                <Footer></Footer>
            </div>
        </div>
        <div v-if="showHackGif" class="hack-gif">
            <h1 class="hack-heading">Hacking in progress ...</h1>
            <video class="hack-video" autoplay controls loop>
                <source :src="getHackerGif()" type="video/mp4" />
            </video>
        </div>
        <div v-if="hackTrue" class="hack-mode-indicator">
            <div>Hack mode</div>
        </div>
    </div>
</template>

<script>
// Project components
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import VFairList from './components/VFairList';
import Countdown from '../components/Countdown';
import TopBannerImage from '~/assets/img/vcf/HeroBanner.png';
import CV from '~/assets/img/vcf/CV.jpg';
import MasterClass from '~/assets/img/vcf/Masterclass.jpg';
import ElevatorPitch from '~/assets/img/vcf/ElevatorPitch.jpg';
import LinkCard from './components/LinkCard';
import Paper from '~/components/builders/Paper';
import Footer from '../components/Footer';
import CompanyList from '~/shared/CompanyList';
import LOGO from '../../../config/LOGO.png';
import hackerman from '../../../assets/video/hackerman.mp4';

import MessageService from '~/services/MessageService';

import { HIGHERED_CV_TEMPLATE } from '~/services/ResourceService';

export default {
    name: 'FindVFairs',
    components: {
        MainLayout,
        VFairList,
        Countdown,
        LinkCard,
        Paper,
        Footer,
        CompanyList,
    },
    computed: {
        vfairs() {
            return this.$interfaces.vfair.get({
                reactive: true,
            });
        },
        nextVFairTimeStamp() {
            const data = this.data();
            if (data.length > 0) {
                return new Date(data[0].start);
            } else {
                return new Date(Date.now());
            }
        },
        hasVFairs() {
            return this.$interfaces.vfairModule.getHasVFairs();
        },
    },
    data() {
        return {
            topBannerImage: TopBannerImage,
            cv: CV,
            elevatorPitch: ElevatorPitch,
            masterClass: MasterClass,
            cvTemplateLink: HIGHERED_CV_TEMPLATE,
            organizations: [],
            companiesLoading: false,
            logo: LOGO,
            showHackGif: false,
            hackClicked: false,
            hackTrue: !!localStorage.getItem('vfair_hack'),
        };
    },
    methods: {
        data() {
            return this.vfairs.data
                .filter(item => {
                    let check = item.start;
                    if (item.end) {
                        check = item.end;
                    }
                    let now = new Date();
                    let then = new Date(check);
                    return now <= then && item.active;
                })
                .sort((a, b) => (a.start > b.start ? 1 : -1));
        },
        loading() {
            return this.vfairs.loading;
        },
        async listenerFunction(event) {
            let hackClicked = false;
            if (event.altKey && event.ctrlKey && event.keyCode === 72 && !hackClicked) {
                hackClicked = true;
                if (localStorage.getItem('vfair_hack')) {
                    localStorage.removeItem('vfair_hack');
                    this.hackTrue = false;
                    MessageService.newMessage('Hack ended', 'Make sure to cover your tracks.');
                    setTimeout(() => {
                        hackClicked = false;
                    }, 2000);
                } else {
                    localStorage.setItem('vfair_hack', 'true');
                    this.hackTrue = true;
                    MessageService.newMessage(
                        'Hacking initialized',
                        'Accessing mainframe...',
                        3000
                    );
                    setTimeout(() => {
                        this.showHackGif = true;
                        setTimeout(() => {
                            this.showHackGif = false;
                            MessageService.newMessage(
                                'Hack Complete',
                                'Access infinite free virtual fairs before its even begun!'
                            );
                            hackClicked = false;
                        }, 3000);
                    }, 3000);
                }
            }
        },
        initializeVFairHack() {
            // Easter Egg functionality. On Ctrl-Alt-H => Access vfairs closed.
            window.addEventListener('keydown', this.listenerFunction);
        },
        getHackerGif() {
            return hackerman;
        },
    },
    mounted() {
        this.initializeVFairHack();
        this.$interfaces.vfairs.organizations.get().then(orgs => {
            this.organizations = [];
            orgs.data.forEach(org => {
                if (
                    org.status === 2 &&
                    this.organizations.find(o => o.id == org.organizationId) === undefined
                ) {
                    this.organizations.push({
                        id: org.organizationId,
                        logo: org.logo,
                        name: org.title,
                    });
                }
            });

            this.companiesLoading = false;
        });
    },
    destroyed() {
        window.removeEventListener('keydown', this.listenerFunction);
    },
};
</script>

<style scoped>
.relativeposition {
    position: relative;
}
.topbanner {
    width: 100%;
}
.headertext {
    width: 100%;
    position: absolute;
    left: 0%;
    top: 50%;
    z-index: 1;
    color: #fff;
    font-size: 32px;
    font-weight: 600;
    text-align: center;
}
.headersubtext {
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 400;
}
.schoolLogo {
    height: 32%;
    position: absolute;
    left: 50%;
    top: 15%;
    z-index: 1;
    padding: 15px;
    background: #fff;
    border-radius: 10px;
    transform: translate(-50%, 0);
}

@media only screen and (max-width: 730px) {
    .schoolLogo {
        display: none;
    }
    .headertext {
        top: 30%;
        font-size: 20px;
    }
    .headersubtext {
        font-size: 8px;
    }
}
.countdownwrapper {
    position: absolute;
    transform: translate(-50%, -100%);
    left: 50%;
}
.hack-gif {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: black;
    z-index: 10000;
    top: 0;
    display: flex;
    flex-direction: column;
}
.hack-video {
    width: 50%;
    margin: auto;
}
.hack-heading {
    color: darkblue;
    text-align: center;
}
.hack-mode-indicator {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: rgba(100, 100, 100, 0.2);
}
</style>
